import dynamic from "next/dynamic";

export const DynamicContent072 = dynamic(() => import("./Content072"), {
  suspense: true,
});
